import { Controller } from "@hotwired/stimulus"
import { useClickOutside } from 'stimulus-use'
export default class extends Controller {
  static targets = ["header", "editForm", "newNameInput", "nameDisplay", "nameStatic"]

  connect() {
    this.isEdit = false;
    this.newName = this.nameDisplayTarget.textContent.trim();
    useClickOutside(this)

    // Listen for successful form submission to update the displayed name
    this.boundHandleSubmitEnd = this.handleSubmitEnd.bind(this)
    this.editFormTarget.querySelector('form')?.addEventListener('turbo:submit-end', this.boundHandleSubmitEnd)
  }

  disconnect() {
    this.editFormTarget.querySelector('form')?.removeEventListener('turbo:submit-end', this.boundHandleSubmitEnd)
  }

  handleSubmitEnd(event) {
    if (event.detail.success) {
      // Update the stored name with the new value from the input
      this.newName = this.newNameInputTarget.value.trim();
      this.isEdit = false;
      this.updateUI();
    }
  }

  toggleEdit(event) {
    event.preventDefault();
    this.isEdit = !this.isEdit;
    this.updateUI();
  }

  clickOutside(event) {
    if (this.isEdit) {
      this.isEdit = false;
      this.updateUI();
    }
  }

  updateUI() {
    this.editFormTarget.style.display = this.isEdit ? "block" : "none";
    this.headerTarget.style.display = !this.isEdit ? "block" : "none";
    this.nameDisplayTarget.textContent = this.newName;
    if (this.isEdit) {
      this.newNameInputTarget.focus()
    }
  }
}
